import { cn } from '@lair-finance/util'
import { AssetIcon } from '@/shared/ui/Asset'
import { Tooltip } from '@/shared/ui/Tooltip'
import { MenuLink } from '@/domains/header/ui/AppMenu/MenuItem.tsx'
import { APP_MENU_LIST } from '@/domains/header/config'
import { useLocation } from 'react-router-dom'
import { useState } from 'react'
import { Logo } from '@/domains/header/ui/Logo.tsx'

export function AppMenu({ className }: { className?: string }) {
  const [open, setOpen] = useState(false)

  return (
    <Tooltip
      open={open}
      onOpenChange={setOpen}
      className={'w-[160px] bg-greyscale-700 p-[7px] border border-greyscale-500 rounded-[8px]'}
      align={'start'}
      sideOffset={8}
      trigger={
        <div className={cn('inline-flex-center gap-x-2', className)}>
          <Logo />
          <AssetIcon filename={open ? 'toggle-on.png' : 'toggle.png'} size={12} />
        </div>
      }
      content={<AppMenuList />}
      noStyle
    />
  )
}

function AppMenuList() {
  const location = useLocation()

  return (
    <div className={'flex flex-col gap-y-1'}>
      {APP_MENU_LIST.map(item => (
        <MenuLink key={item.name} to={item.path} active={item.isActive(location.pathname)}>
          {item.name}
          {item.isNew && <span className={'ml-2 inline-flex-center px-1 h-4 rounded-[4px] bg-primary-500 text-greyscale-50 typo-label-3'}>New</span>}
        </MenuLink>
      ))}
    </div>
  )
}
